import { render, staticRenderFns } from "./AdmissionData.vue?vue&type=template&id=0917278c&scoped=true"
import script from "./AdmissionData.vue?vue&type=script&lang=js"
export * from "./AdmissionData.vue?vue&type=script&lang=js"
import style0 from "./AdmissionData.vue?vue&type=style&index=0&id=0917278c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0917278c",
  null
  
)

export default component.exports